import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SideDrawer from './Drawer';
import { Grid, ListItemIcon } from '@mui/material';
import { Logout } from '@mui/icons-material';
import AppLogo from './AppLogo';
import SearchBar from './SearchBar';
import { clearLocalStorage, getAuthToken } from '../../../utils';
import { useCommonStyles } from '../../../common/common';
import { AppState } from '../../../store';
import { SIGNOUT_AUTH_SUCCESS } from '../../../constants/ActionTypes';
import { showSuccessMessage } from '../../../common/Toaster';

interface NavigationBarProps {
	location: { pathname: string };
}

const NavigationBar = (props: NavigationBarProps) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	
	const { cartItems } = useSelector<AppState, AppState['cart']>(
		({ cart }) => cart,
	);
	const { user } = useSelector<AppState, AppState['auth']>(
		({auth}) => auth,
	);
	
	const authUser = localStorage.getItem("auth_user")
	const parsedAU = authUser && JSON.parse(authUser)
	const isMenuOpen = Boolean(anchorEl);

	const history = useHistory()
	const dispatch = useDispatch()
	const isAuthenticated = getAuthToken()
	const classes = useCommonStyles()

	const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleShoppingCartMenuOpen = (event: any) => {
		history.push('/cartItems')
	}

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleLogoutMenu = () => {
		clearLocalStorage()
		setAnchorEl(null)
		dispatch({ type: SIGNOUT_AUTH_SUCCESS })
		showSuccessMessage("Logged out succesfully!", 'top-center')
		history.push('/products')
	}

	const handleManageAccount = (event: any) => {
		history.push('/admin/dashboard')
		setAnchorEl(null)
	}

	const OnMyAccountClick = (event: any) => {
		setAnchorEl(null)
		history.push('/profile');
	}

	const menuId = 'primary-search-account-menu';
	const renderMenu = (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			id={menuId}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={isMenuOpen}
			onClose={handleMenuClose}
		>
			<MenuItem onClick={OnMyAccountClick}>My Account</MenuItem>
			<MenuItem onClick={handleMenuClose}>Orders</MenuItem>
			{((user && user.isSeller)
				|| (parsedAU && parsedAU.isSeller)) 
				&& <MenuItem onClick={handleManageAccount}>Your Seller Account</MenuItem>
			}
			<MenuItem onClick={handleLogoutMenu}>
				<ListItemIcon>
					<Logout fontSize="small" />
				</ListItemIcon>Logout
			</MenuItem>
		</Menu>
	);

	const onLogoClick = () => {
		history.push('/products')
	}
	const path: string = props.location.pathname
	if(path.indexOf('admin') > -1) {
		return <></>
	}
	return (
		<Box mx={{ flexGrow: 1, width: '100%' }}>
			<AppBar position="static">
				<Toolbar>
					<Grid container display="flex" alignItems="center">
						<Grid item xs={2} md={3} lg={2} display="flex" alignItems="center">
							<SideDrawer />
							<Typography
								variant="h6"
								noWrap
								component="div"
								sx={{ display: { xs: 'none', sm: 'block' } }}
							>
								{/* <AppLogo onClick={onLogoClick} /> */}
							</Typography>
						</Grid>
						<Grid item xs={7} md={6} lg={8}>
							<SearchBar />
						</Grid>
						<Grid item xs={3} md={3} lg={2}>
							<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
								<Box display="flex" flexDirection="column" alignItems="center" p={1} pl={2} fontSize="12px">
									<Box sx={{ display: { xs: 'none', sm: 'block' } }}>
										{isAuthenticated && `Hello ${parsedAU && parsedAU.name}`}
										{!isAuthenticated && <Link className={classes.loginLink} to="/signin">Hello Signin</Link>}
									</Box>
									<Box sx={{ display: { xs: 'none', sm: 'block' } }} onClick={handleProfileMenuOpen}><b>Account and List <ArrowDropDownIcon /></b></Box>
									{!isAuthenticated && <Box sx={{ display: { xs: 'flex', sm: 'none', flexDirection: 'column', alignItems: 'center' } }}>
										<Link className={classes.loginLink} to="/signin"> Signin</Link>
									</Box>}
									<Box sx={{ display: { xs: 'block', sm: 'none' } }} onClick={handleProfileMenuOpen}><AccountCircleIcon /></Box>
								</Box>
								<IconButton
									size="large"
									edge="end"
									aria-label="shopping cart"
									aria-controls={menuId}
									aria-haspopup="true"
									onClick={handleShoppingCartMenuOpen}
									color="inherit"
								>
									<Badge badgeContent={(cartItems && cartItems.length) || 0} color="warning">
										<ShoppingCartIcon />
									</Badge>
								</IconButton>
								
							</Box>
						</Grid>
					</Grid>
				</Toolbar>
			</AppBar>
			{isAuthenticated && renderMenu}
		</Box>
	);
}

export default NavigationBar;
